export default __webpack_public_path__ + "media/zurb/img/growth-design/funnels-desktop-02276c885d28c4baea0e5d944093706e.png";